import React from "react";
import {Avatar as AvatarComponent} from "@mui/material";
import {getLeagueAvatarUrl} from "data/utils/avatar";
import defaultAvatar from "assets/img/icons/avatar.svg";

interface IAvatar {
	leagueId: number;
	avatarVersion: number;
	className?: string;
	alt?: string;
	variant?: "circular" | "square";
}

export const LeagueAvatar: React.FC<IAvatar> = ({
	className,
	alt = "Avatar",
	leagueId,
	avatarVersion,
	variant = "circular",
}) => {
	if (avatarVersion) {
		return (
			<AvatarComponent
				alt={alt}
				src={getLeagueAvatarUrl(leagueId, avatarVersion)}
				className={className}
				variant={variant}
				sx={{width: 52, height: 52}}>
				<img src={defaultAvatar} alt="" />
			</AvatarComponent>
		);
	}

	return (
		<AvatarComponent
			alt={alt}
			src={defaultAvatar}
			className={className}
			variant={variant}
			sx={{width: 52, height: 52}}
		/>
	);
};
